import "./shipping-label.styles.scss";
import { useState } from "react";
import DefaultButton from "../../default/default.button.component";
import ShippingLabelCreateModal from "../../../modals/create/shipping-label/shipping-label.create.modal.component";

const ShippingLabelCreateButton = ({ addLabel }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <DefaultButton label="New Label" onClick={() => setShowModal(true)} />
      <ShippingLabelCreateModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSuccess={addLabel}
      />
    </>
  );
};

export default ShippingLabelCreateButton;
